<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ServiceTypeList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ServiceTypeList from '@/components/settings/parameters/serviceTypes/ServiceTypeList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'ServiceTypes',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      ServiceTypeList
    },
    methods: {
      onClickButton (e) {
        this.$router.push({ name: 'addservicetype' })
      }
    }
  }
</script>
